require('bootstrap');

const prayerForm = document.getElementById('prayer-form');
prayerForm.addEventListener('change', e => {
    if (e.target.classList && e.target.classList.contains('is-invalid')) {
        if (e.target.value.length > 0) {
            e.target.classList.remove('is-invalid');
            e.target.nextElementSibling.innerText = '';
        }
    }
});

prayerForm.addEventListener('submit', e => {
    e.preventDefault();
    const f = e.target;

    f.querySelectorAll('.is-invalid, .invalid-feedback').forEach(el => {
        if (el.classList.contains('is-invalid')) {
            el.classList.remove('is-invalid');
        } else {
            el.innerText = '';
        }
    });

    if (!f.querySelector('#agree').checked) {
        alert('동의에 체크해주세요.');
        f.querySelector('#agree').focus();
        return false;
    }

    const fd = new FormData(f);
    axios.post(f.action, fd)
         .then(r => {
             f.reset();
             const msg = document.getElementById('prayer-request-result');
             msg.style.display = '';
             setTimeout(() => {
                 msg.style.display = 'none';
             }, 3000);

         })
         .catch(err => {
             console.log(err.response ? err.response : err);
             if (err.response && err.response.status === 422) {
                 const errors = err.response.data.errors;
                 const keys = Object.keys(errors);
                 keys.forEach(key => {
                     const val = errors[key][0];
                     const item = f.querySelector(`[name="${key}"]`);
                     if (item) {
                         item.classList.add('is-invalid');
                         item.nextElementSibling.innerText = val;
                     }
                 });
             }
         });
});
